import { useQuery } from '@tanstack/react-query';
import { useStateKey } from '../../../iwQueryClient/useStateKey';
import { fetchGetBuyerSellerDirectory } from '@iwoca/lapi-client/iwocapay';

export const useSellerDirectory = () => {
    const stateKey = useStateKey();
    const { data, error } = useQuery({
        queryKey: ['fetchGetSellerDirectory', stateKey!],
        queryFn: () => fetchGetBuyerSellerDirectory({ stateKey: stateKey! })
    });

    return {
        sellers: data?.data.sellers,
        error: error
    };
};
